import { useId, type ComponentProps } from 'react';
import { Icon } from '@plone/components';

const YoutubeSVG = (props: Omit<ComponentProps<typeof Icon>, 'children'>) => {
  const pathId = useId();

  return (
    <Icon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
        <defs>
          <clipPath id={pathId}>
            <path fill="none" d="M3.59 6.2H24.4v15.6H3.59z" />
          </clipPath>
        </defs>
        <g clip-path={`url(#${pathId})`}>
          <path
            fill="currentColor"
            d="M20.3 6.2H7.7a4.1 4.1 0 0 0-4.1 4.1v7.39a4.1 4.1 0 0 0 4.1 4.1h12.6a4.1 4.1 0 0 0 4.1-4.1V10.3a4.1 4.1 0 0 0-4.1-4.1"
          />
          <path
            fill="#fff"
            d="M11.03 17.42v-6.84c0-.54.59-.88 1.05-.6l5.72 3.42c.45.27.45.92 0 1.2l-5.72 3.42c-.46.28-1.05-.06-1.05-.6"
          />
        </g>
      </svg>
    </Icon>
  );
};

export default YoutubeSVG;
